const isLegacyBrowser = () => !!window.ShadyDOM;

export default isLegacyBrowser;
